import React from 'react'
import { Typography } from '@giffgaff/fe-design-system-ui'

export const BLACK_FRIDAY_TERMS: React.ReactNode[] = [
  <Typography key="phone-promo" color="$colorSurfaceTextVerySubtle" variant="bodyXXS">
    *£18.87/mo, 36 month direct debit credit agreement (0% APR). Plus plan: £12/mo, 200GB data for 18 months
    (promotional offer is 200GB/mo, 18 month commitment, then 50GB/mo). Phone finance by Klarna Financial Services UK
    Limited, SE1 7ND and subject to status, late fees and Klarna T&Cs. 256GB phone was £1159, now £699. 18+. Ends
    7/12/26 at 23:59. Fair usage policy, data roaming restrictions, eligibility criteria and terms apply. See{' '}
    <a href="/terms">giffgaff.com/terms</a>
  </Typography>,
  <Typography key="plan-promo" color="$colorSurfaceTextVerySubtle" variant="bodyXXS">
    ** Offer on £12 50GB 18 month plan. Activate plan by 7/12/26. Existing members opt in via the app. Eligibility
    criteria, terms and exclusions apply. See <a href="/terms/promotions">giffgaff.com/terms/promotions</a>
  </Typography>,
]
